var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","small":""},on:{"click":function($event){return _vm.$emit('toggleShowArchived')}}},on),[_c('v-icon',{attrs:{"color":_vm.value ? 'red' : 'grey lighten-1'}},[_vm._v("mdi-archive")])],1)]}}])},[_c('span',[_vm._v(" "+_vm._s(_vm.tooltipMessage)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }